import { z } from "zod";
import { AD_PRODUCT_PURCHASED_CHOICE } from "./checkout/schema/AdProductChoice";
import { AD_PRODUCT_KEY_SCHEMA } from "./checkout/schema/AdProductKey";

const AD_CONFIG_PRODUCT_SCHEMA_BASE = z.object({
  key: AD_PRODUCT_KEY_SCHEMA,
});

const AD_CONFIG_EXPIRING_PRODUCT_SCHEMA = AD_CONFIG_PRODUCT_SCHEMA_BASE.extend({
  expiresAt: z.date(),
});

const AD_CONFIG_TRANSIENT_PRODUCT_SCHEMA = AD_CONFIG_PRODUCT_SCHEMA_BASE.extend(
  {}
);

export const AD_CONFIG_PRODUCT_SCHEMA = z.union(
  [AD_CONFIG_EXPIRING_PRODUCT_SCHEMA, AD_CONFIG_TRANSIENT_PRODUCT_SCHEMA],
  "Invalid ad config product"
);

export const AD_PRICING_MODEL_CODES = ["standard", "free_basic"] as const;

const AD_PRICING_MODEL_SCHEMA = z.enum(AD_PRICING_MODEL_CODES);

export type AdPricingModel = z.infer<typeof AD_PRICING_MODEL_SCHEMA>;

export const AD_CONFIG_STATE_SCHEMA = z.object({
  pricing: AD_PRICING_MODEL_SCHEMA,
  purchases: z.array(AD_PRODUCT_PURCHASED_CHOICE),
  products: z
    .partialRecord(AD_PRODUCT_KEY_SCHEMA, AD_CONFIG_PRODUCT_SCHEMA)
    .optional(),
});

export type AdConfigState = z.infer<typeof AD_CONFIG_STATE_SCHEMA>;

export type AdConfigProduct = z.infer<typeof AD_CONFIG_PRODUCT_SCHEMA>;

export const AD_CONFIG_STATE_DEFAULTS: AdConfigState = {
  pricing: "standard",
  purchases: [],
  products: {},
};
